import type { JSX } from 'react';
import { Chip, type Denomination } from './Chip.js';
import './ChipStack.css';

/**
 * A rack of chips. Purely a picture of quantity — the readable number is always
 * ChipCount, so this never has to be counted to be understood.
 */

export interface ChipStackProps {
  /** Chips in the stack. */
  count: number;
  /** Denomination of every chip in it. Gold is the brand metal (§5.1). */
  value?: Denomination;
  /** Diameter of one chip in px. */
  size?: number;
  /** Chips drawn before the stack is capped; taller than this reads as noise. */
  max?: number;
  className?: string;
}

export function ChipStack({
  count,
  value = 1000,
  size = 34,
  max = 8,
  className,
}: ChipStackProps): JSX.Element {
  const drawn = Math.min(Math.max(0, Math.floor(count)), max);
  return (
    <div
      className={className === undefined ? 'chip-stack' : `chip-stack ${className}`}
      aria-hidden="true"
    >
      {Array.from({ length: drawn }, (_, i) => (
        <Chip key={i} value={value} size={size} />
      ))}
    </div>
  );
}
